import Vue from 'vue'

const state = {
  // we init state with local storage profile
  profile: localStorage.getItem('profile')
    ? JSON.parse(localStorage.getItem('profile'))
    : {},
  // F_MESS_5 — compteur messages non-lus (polling, non persisté en localStorage)
  unreadCount: 0,
}

const getters = {
  getProfile: state => state.profile,
  getUnreadCount: state => state.unreadCount,
  getRegistrationProcess: state => {
    // parse registration process stored as a string
    return typeof state.profile?.registration_process === 'string'
      ? JSON.parse(state.profile.registration_process)
      : { reason: '', partner: {} }
  }
}

const actions = {
  // request profile from API and update local storage
  profileRequest: async ({ commit, dispatch }) => {
    // console.log('load profile from api')
    await Vue.axios.get('/api/user', { params: { with: ['mailboxAlias'] } })
      .then((resp) => {
        commit('profileSuccess', resp.data.data)
      })
      .catch(() => {
        // if resp is unauthorized, logout, to
        dispatch('authLogout')
      })
  },
  updateRegistrationProcess: async ({ state, commit }, registrationProcess) => {
    //console.log('update local registration', JSON.stringify(state.profile))
    commit('profileSuccess', { ...state.profile, registration_process: JSON.stringify(registrationProcess) })
  },
  // F_MESS_5 — Interroge le count de non-lus (polling)
  fetchUnreadCount: async ({ commit, getters }) => {
    const profile = getters.getProfile
    if (!profile || profile.role !== 'pro') return
    const alias = profile.mailbox_alias
    const hasActiveAlias = alias && alias.validated_at && !alias.is_blocked && !alias.deleted_at
    if (!hasActiveAlias || !profile.mailbox_consent_at) return
    return Vue.axios.get('/api/mailbox/conversations', { params: { unread: 1 } })
      .then(resp => { commit('setUnreadCount', resp.data.unread_count ?? 0) })
      .catch(() => { /* silencieux — ne pas interrompre l'UX si le poll échoue */ })
  },
  mailboxConsentRequest: async ({ state, commit }) => {
    return Vue.axios.post('/api/mailbox/consent')
      .then((resp) => {
        commit('profileSuccess', {
          ...state.profile,
          mailbox_consent_at: resp.data.mailbox_consent_at,
        })
      })
  },
}

const mutations = {
  setUnreadCount: (state, count) => {
    state.unreadCount = count
  },
  decrementUnreadCount: (state, by = 1) => {
    state.unreadCount = Math.max(0, state.unreadCount - by)
  },
  profileSuccess: (state, profile) => {
    // console.log('update local storage profile:', profile)
    localStorage.setItem('profile', JSON.stringify(profile))
    Vue.set(state, 'profile', profile)
  },
  profileRemove: (state) => {
    // console.log('clear local storage profile')
    localStorage.removeItem('profile')
    Vue.set(state, 'profile', {})
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
